/**
 * Канонические имена целей. Не переименовывать — отчёты Яндекс.Метрики
 * группируются по этим строкам, переименование в коде = потеря истории
 * цели в дашборде Метрики.
 *
 * Для filter-applied используется одно имя цели с параметром
 * `filter_type`, а не пять отдельных целей: агрегировать в Метрике
 * проще, чем разбивать, а нарезка по параметрам там всё равно доступна.
 */

export const ANALYTICS_GOALS = {
  EXPORT_ESTIMATE: 'export_estimate',
  EXPORT_MODAL_OPENED: 'export_modal_opened',
  FILTER_APPLIED: 'filter_applied',
} as const;

export type FilterType =
  | 'platform'
  | 'format'
  | 'template'
  | 'category'
  | 'category_mode'
  | 'tag'
  | 'tag_mode'
  | 'tag_scope'
  | 'freshness';
